<template>
  <div class="d-sm-flex fill-height" style="overflow: hidden auto;">
    <v-list max-width="390px" class="flex-shrink-0">
      <v-subheader>Предзаполнение полей в документах для электронной подписи клиентом</v-subheader>
      <v-list-item-group v-model="selected" color="primary darken-3">
        <v-list-item
          v-for="(doc, key) of documentsWithTemplateFields"
          :key="key"
          :value="key"
        >
          <v-list-item-content>
            <v-list-item-title>{{ doc.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>

    <v-divider class="d-none d-sm-block" vertical></v-divider>

    <v-container fill-height fluid>
      <v-row v-if="selected" class="align-self-start">
        <v-col cols="12">
          <div v-for="(field, key) of documentsWithTemplateFields[selected].template_fields" :key="`${selected}-${key}`">
            <v-radio-group
              v-if="field.type === 'radiobutton'"
              :value="template_fields_input[selected] && template_fields_input[selected][key]"
              @change="updateUserInput(selected, key, $event)"
            >
              <template #label>
                <span class="text-caption" v-text="field.title"></span>
              </template>

              <template #default>
                <v-radio
                  v-for="(inputField, inputFieldKey) of field.value"
                  :key="`${key}-${inputFieldKey}`"
                  :label="inputField.title"
                  :value="inputFieldKey"
                ></v-radio>
              </template>
            </v-radio-group>
            <template v-else-if="field.type === '$tariff'">
              <span class="v-label theme--light text-caption" v-text="field.title"></span>
              <v-select
                :value="template_fields_input[selected] && template_fields_input[selected][key]"
                class="mb-6"
                hide-details
                :menu-props="{ bottom: true, offsetY: true }"
                single-line
                dense
                item-text="title"
                item-value="alias"
                :items="tariffs"
                label="Тарифы"
                outlined
                @change="updateUserInput(selected, key, $event)"
              ></v-select>
            </template>
          </div>
        </v-col>
      </v-row>

      <v-row v-show="!selected" justify="center" class="align-self-center">
        <span class="headline blue-grey--text text--lighten-2 font-weight-light">Выберите тип документа</span>
      </v-row>

      <v-checkbox
        v-model="confirmInput"
        :disabled="!filled"
        label="Проверьте что все данные верны, переотправить на переподписание будет затруднительно"
        dense
        @change="onConfirmInput"
      ></v-checkbox>
    </v-container>
  </div>
</template>

<script>
import { required } from '@/utils/rules';
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";

export default {
  data: () => ({
    selected: null,

    filled: false,
    confirmInput: false,

    rules: {
      required,
    }
  }),

  computed: {
    ...mapState("meeting", ["currentMeetingId", "template_fields_input"]),
    ...mapGetters("meeting", ["template_fields", "meetingdocs", "tariffs"]),

    documentsWithTemplateFields() {
      const docsWithTemplateFields = this.meetingdocs?.filter((doc) => doc.template_fields != null);
      if (!docsWithTemplateFields?.length) return null;

      return Object.fromEntries(docsWithTemplateFields.map((doc) => [doc.name, {
        title: doc.title,
        template_fields: doc.template_fields
      }]));
    },
  },

  mounted() {
    const totalDocuments = this.documentsWithTemplateFields ? Object.keys(this.documentsWithTemplateFields) : null;
    if (totalDocuments?.length === 1) {
      // выбираем первый документ если их всего один, и не было выбрано ничего до этого
      this.selected ??= totalDocuments[0];
    }
  },

  methods: {
    updateUserInput(document, key, value) {
      this.$store.commit('meeting/setTemplateFieldsInput', {
        document,
        input: { [key]: value }
      });

      let allFilled = true;
      for (const doc_key in this.documentsWithTemplateFields) {
        for (const template_field_key in this.documentsWithTemplateFields[doc_key].template_fields) {
          if (!this.template_fields_input[doc_key][template_field_key]) {
            allFilled = false;
            break;
          }
        }
      }

      if (this.filled !== allFilled) {
        this.filled = allFilled;
        this.confirmInput = false;
      }
    },

    onConfirmInput(value) {
      if (!this.filled) return;

      this.$store.commit('meeting/setTemplateFieldsFilled', Boolean(value));
    }
  }
};
</script>
